// import React,{ Component } from 'react';

function PublicLayout(props) {
	return  props.children;
}

export default PublicLayout;
